<template>
  <div class="guide-wrapper">
    <h2>
      学籍认证报告获取流程
    </h2>
    <h3>
      第一步
    </h3>
    <div class="content">
      <a :href="guideUrl" target="_blank">登录学信网：</a>{{ guideUrl }}
    </div>
    <h3>
      第二步
    </h3>
    <div class="content">
      鼠标悬浮在线验证报告-点击高等学籍
      <img @click="previewImage(1)" src="@/assets/backCheckGuide1.png" />
    </div>
    <h3>
      第三步
    </h3>
    <div class="content">
      选择适合的方式，按流程申请学籍认证报告
      <img @click="previewImage(2)" src="@/assets/backCheckGuide2.png" />
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
export default {
  data: function() {
    return {
      guideUrl:
        'https://account.chsi.com.cn/passport/login?service=https%3A%2F%2Fmy.chsi.com.cn%2Farchive%2Fj_spring_cas_security_check',
    }
  },
  methods: {
    previewImage(index) {
      let image = require(`@/assets/backCheckGuide${index}.png`)
      ImagePreview([image])
    },
  },
}
</script>
<style lang="less" scoped>
.guide-wrapper {
  margin: 0 auto;
  padding: 15px 15px 48px;
  max-width: 750px;
  height: 100vh;
  overflow: auto;
  .content {
    word-break: break-all;
    margin-bottom: 15px;
    img {
      margin-top: 5px;
      width: 100%;
    }
  }
}
</style>
